import React, { useRef, useState, useEffect } from "react";
import {
  Button,
  FormGroup,
  Label,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  Card,
  CardBody,
} from "reactstrap";
import moment from "moment";
import { Field, Formik } from "formik";
import useAxios from "hooks/useAxios";
import Calendar from "assets/icon/calendar-icon.svg";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import ReactStrapTable from "components/reactStrapTable";
import {
  invoiceDetailColumns,
  currencyFormat,
  dateFormate,
} from "utils/columns";
import { onExport } from "utils/helper";
import HoverImage from "react-hover-image/build";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import CancleIcon from "assets/icon/icon-icon-options-not-eligible.svg";
import SaveIcon from "assets/icon/icon-icon-options-order-complete.svg";
import CancleHoverIcon from "assets/icon/icon-icon-options-not-eligible-hover.svg";
import SaveHoverIcon from "assets/icon/icon-icon-options-order-complete-hover.svg";
import DeleteIcon from "assets/icon/icon-icon-options-delete.svg";
import DeleteHoverIcon from "assets/icon/Delete Hover.svg";
import { toast } from "react-toastify";
import { cloneDeep } from "lodash";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";
import { NumericFormat } from "react-number-format";
import Confirm from "components/Confirm";
import Loader from "components/Loader";
import RefreshIcon from "assets/icon/RefreshIcon.svg";
import ExportIcon from "assets/icon/Download-Icon3.svg";

let rowForEdit = {},
  updatedFields = {
    totalPayment: 0,
    dispFee: 0,
    ceReceivable: 0,
    drug340BCost: 0,
    netProfit: 0,
    rcsFee: 0,
  };
let hasDatePopupOpen = false;

const ManualInvoice = ({
  coveredEntityID,
  tenantID,
  rcsFeeBase,
  rcsFee,
  invoiceID,
  onSearch,
  selectedCoveredEntity,
  toggle,
  invStartDate,
}) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const API = useAxios();
  const [invoiceData, setInvoiceData] = useState([]);
  const [bkpInvData, setBkpInvData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorStart, setErrorStart] = useState(false);
  const [errorEnd, setErrorEnd] = useState(false);
  const [hideGenerateButton, setHideGenerateButton] = useState(true);
  const [totalPaid, setTotalPaid] = useState("");
  const [dispFee, setDispFee] = useState("");
  const [ceReceivable, setCEReceivalbe] = useState("");
  const [drug340BConst, setDrug340BConst] = useState("");
  const [profitloss, setProfitloss] = useState("");
  const [newRcsFee, setNewRcsFee] = useState("");
  const [isConfirm, setConfirm] = useState(false);
  const [isDeleteConfirm, setDeleteConfirm] = useState(false);
  const [claimID, setClaimID] = useState("");
  const formikRef = useRef();
  const [maxDate, setMaxDate] = useState(null);
  const [state, updateState] = useState({
    tableData: [],
    backUpData: [],
  });

  const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

  useEffect(() => {
    setStartDate(invStartDate);
    let now = dateFormate(new Date());
    setMaxDate(now);
    if (invoiceID > 0) {
      fetchClaimData();
    }
  }, []);

  const editRow = (rowData, isEdit = true) => {
    rowForEdit = {};
    if (isEdit === false) {
      fetchClaimData();
      return;
    }
    updatedFields = {
      totalPayment: 0,
      dispFee: 0,
      ceReceivable: 0,
      drug340BCost: 0,
      netProfit: 0,
      rcsFee: 0,
    };
    let tempData = [...invoiceData];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.claimID === rowData?.claimID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    setState({
      backUpData: tempData,
      tableData: tempData,
    });
  };

  const renderInvoiceOption = (row) => {
    if (row.isEdit) {
      return (
        <div className="d-flex align-items-center">
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={saveUpdateRow}
          >
            <HoverImage
              key="SaveIcon"
              src={SaveIcon}
              hoverSrc={SaveHoverIcon}
              alt=""
            />
          </Button>
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => editRow(row, false)}
          >
            <HoverImage
              key="CancelIcon"
              src={CancleIcon}
              hoverSrc={CancleHoverIcon}
              alt=""
            />
          </Button>
        </div>
      );
    } else {
      return (
        <div className="d-flex align-items-center">
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => editRow(row)}
          >
            <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
          </Button>

          <Button
            hidden={invoiceID == 0}
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => deleteRow(row)}
          >
            <HoverImage src={DeleteIcon} hoverSrc={DeleteHoverIcon} alt="" />
          </Button>
        </div>
      );
    }
  };

  const saveUpdateRow = async () => {
    try {
      setLoading(true);
      let result = await API.post(
        `/${tenantID}/Invoice/UpdateClaimFinanceData`,
        rowForEdit,
        {
          hideLoader: true,
        }
      );
      if (result) {
        toast.success(
          "Item updated successfully, click on regenerate invoice for the reflection."
        );
        setLoading(false);
        fetchClaimData();
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const updateRowValue = (e, col) => {
    let value = isNaN(e.target.value) ? 0 : parseFloat(e.target.value);
    rowForEdit[col] = value;
    if (col === "totalPayment") {
      setTotalPaid(value);
    } else if (col === "dispFee") {
      setDispFee(value);
    } else if (col === "drug340BCost") {
      setDrug340BConst(value);
    }
    let ceRec = rowForEdit.totalPayment - rowForEdit.dispFee;
    setCEReceivalbe(ceRec);
    rowForEdit["ceReceivable"] = ceRec;

    let netProft = rowForEdit.ceReceivable - rowForEdit.drug340BCost;
    setProfitloss(netProft);
    rowForEdit["netProfit"] = netProft;

    if (rcsFeeBase == "PL") {
      rowForEdit.rcsFee = (rowForEdit.netProfit * rcsFee).toFixed(2);
      setNewRcsFee(rowForEdit.rcsFee);
    } else {
      rowForEdit.rcsFee = (rowForEdit.ceReceivable * rcsFee).toFixed(2);
      setNewRcsFee(rowForEdit.rcsFee);
    }
  };

  const cellEditRender = (
    row,
    col,
    formatterType,
    disabled,
    alwaysEditableCheckbox
  ) => {
    if (col.dataField === "totalPayment" && row.isEdit) {
      setTotalPaid(row.totalPayment);
      return (
        <NumericFormat
          type="text"
          disabled={disabled}
          name={col.dataField}
          id={col.dataField}
          decimalScale={2}
          value={totalPaid}
          onChange={(e) => {
            updateRowValue(e, "totalPayment");
          }}
          autoComplete="off"
          className={"required form-control"}
        />
      );
    } else if (col.dataField === "dispFee" && row.isEdit) {
      setDispFee(row.dispFee);
      return (
        <NumericFormat
          type="text"
          disabled={disabled}
          name={col.dataField}
          id={col.dataField}
          decimalScale={2}
          value={dispFee}
          onChange={(e) => {
            updateRowValue(e, "dispFee");
          }}
          autoComplete="off"
          className={"required form-control"}
        />
      );
    } else if (col.dataField === "ceReceivable" && row.isEdit) {
      setCEReceivalbe(row.ceReceivable);
      return (
        <NumericFormat
          type="text"
          disabled={disabled}
          name={col.dataField}
          id={col.dataField}
          decimalScale={2}
          value={ceReceivable}
          onChange={(e) => {
            updateRowValue(e, "ceReceivable");
          }}
          autoComplete="off"
          className={"required form-control"}
        />
      );
    } else if (col.dataField === "drug340BCost" && row.isEdit) {
      setDrug340BConst(row.drug340BCost);
      return (
        <NumericFormat
          type="text"
          disabled={disabled}
          name={col.dataField}
          id={col.dataField}
          decimalScale={2}
          value={drug340BConst}
          onChange={(e) => {
            updateRowValue(e, "drug340BCost");
          }}
          autoComplete="off"
          className={"required form-control"}
        />
      );
    } else if (col.dataField === "netProfit" && row.isEdit) {
      setProfitloss(row.netProfit);
      return (
        <NumericFormat
          type="text"
          disabled={disabled}
          name={col.dataField}
          id={col.dataField}
          decimalScale={2}
          value={profitloss}
          onChange={(e) => {
            updateRowValue(e, "netProfit");
          }}
          autoComplete="off"
          className={"required form-control"}
        />
      );
    } else if (col.dataField === "rcsFee" && row.isEdit) {
      setNewRcsFee(row.rcsFee);
      return (
        <NumericFormat
          type="text"
          disabled={disabled}
          name={col.dataField}
          id={col.dataField}
          decimalScale={2}
          value={newRcsFee}
          onChange={(e) => {
            updateRowValue(e, "rcsFee");
          }}
          autoComplete="off"
          className={"required form-control"}
        />
      );
    } else {
      return <>{currencyFormat(row[col.dataField])}</>;
    }
  };

  let copyCommonColumns = cloneDeep(invoiceDetailColumns);

  copyCommonColumns[8].cellRenderer = (row, col) =>
    cellEditRender(row, col, "number");
  copyCommonColumns[9].cellRenderer = (row, col) =>
    cellEditRender(row, col, "number");
  copyCommonColumns[10].cellRenderer = (row, col) =>
    cellEditRender(row, col, "number", true);
  copyCommonColumns[11].cellRenderer = (row, col) =>
    cellEditRender(row, col, "number");
  copyCommonColumns[12].cellRenderer = (row, col) =>
    cellEditRender(row, col, "number", true);
  copyCommonColumns[13].cellRenderer = (row, col) =>
    cellEditRender(row, col, "number", true);

  let columns = [
    {
      dataField: "edit",
      text: "Options",
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
      cellRenderer: (row) => renderInvoiceOption(row),
    },
    ...copyCommonColumns,
  ];

  const handleExport = () => {
    let { tenantID, coveredEntityID } = selectedCoveredEntity;

    const { access_token } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};

    let stDate = startDate.replace(/\//g, "-");
    let edDate = endDate.replace(/\//g, "-");
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Invoice/ManualInvoiceExportAll/${coveredEntityID}/${stDate}/${edDate}?access_token=${access_token}`;
    onExport(action);
  };
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  const handleStartDate = (startDate) => {
    let startDt = moment(new Date(startDate)).format("MM/DD/YYYY");
    setStartDate(startDt);
    setErrorStart(false);
  };

  const handleEndDate = (endDate) => {
    let endDt = moment(new Date(endDate)).format("MM/DD/YYYY");
    setEndDate(endDt);
    setErrorEnd(false);
  };

  const handleClaims = () => {
    if (startDate === null) {
      setErrorStart(true);
      return;
    }
    if (endDate === null) {
      setErrorEnd(true);
    }
    fetchClaimData();
  };

  const fetchClaimData = async () => {
    try {
      setLoading(true);
      setState({ loading: true });
      let payload = {};
      payload.coveredEntityID = coveredEntityID;
      payload.fromInvoiceDate = invoiceID > 0 ? "01/01/1999" : startDate;
      payload.toInvoiceDate = invoiceID > 0 ? "01/01/1999" : endDate;

      let checkValidDates = await API.post(
        `/${tenantID}/Invoice/checkinvoicedatevalidity/${coveredEntityID}`,
        payload,
        {
          hideLoader: true,
        }
      );

      if (checkValidDates || invoiceID > 0) {
        if (checkValidDates.data || invoiceID > 0) {
          let result = await API.post(
            `/${tenantID}/Invoice/GetAllClaims/${coveredEntityID}/${invoiceID}`,
            payload,
            {
              hideLoader: true,
            }
          );
          if (result) {
            if (result.data.length > 0) {
              setHideGenerateButton(false);
            }
            setInvoiceData(result.data);
            let data = cloneDeep(result.data);
            setBkpInvData(data);
            setState({ loading: false });
            setLoading(false);
          }
        } else {
          toast.error("Invoice date conflicts in given date ranges");
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const deleteRow = async (rowData) => {
    handleDeleteConfirmation();
    if (rowData.claimID) {
      setClaimID(rowData.claimID);
    }
    let result = await API.post(
      `/${tenantID}/Invoice/inactiveclaim/${invoiceID}/${claimID}`,
      null,
      {
        hideLoader: true,
      }
    );
    if (result) {
      toast.success(
        "Item removed successfully, click on regenerate invoice for the reflection"
      );
      fetchClaimData();
    }
  };

  const handleSaveConfirmation = () => {
    setConfirm(!isConfirm);
  };

  const handleDeleteConfirmation = () => {
    setDeleteConfirm(!isDeleteConfirm);
  };

  const handleGenerateInvoice = async (val, action) => {
    handleSaveConfirmation();
    try {
      setHideGenerateButton(true);
      setLoading(true);
      let payload = {};
      payload.coveredEntityID = coveredEntityID;
      payload.fromInvoiceDate = invoiceID > 0 ? "01/01/1999" : startDate;
      payload.toInvoiceDate = invoiceID > 0 ? "01/01/1999" : endDate;

      let result = await API.post(
        `/${tenantID}/Invoice/GenerateInvoice/${coveredEntityID}/${invoiceID}`,
        payload,
        {
          hideLoader: true,
        }
      );

      if (result) {
        if (result.data) {
          toast.success("Invoice saved successfully.");
          let filters = {
            coveredEntityName: selectedCoveredEntity.coveredEntityID.toString(),
          };
          toggle(true);
          await onSearch(filters);
          setLoading(false);
        } else {
          setHideGenerateButton(false);
          setLoading(false);
          toast.error("Invalid data found");
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>

      {loading && <Loader opacity={0.01} color="black" />}
      <Formik
        innerRef={formikRef}
        onSubmit={handleGenerateInvoice}
        enableReinitialize={true}
        children={(props) => {
          return (
            <div>
              <Row sm={5} hidden={invoiceID > 0}>
                <Col md={6}>
                  <Row>
                    <Col>
                      <FormGroup className="start-date-invoice">
                        <Label>Start Date</Label>
                        <InputGroup onMouseLeave={handleMouseLeave}>
                          <Field
                            type="text"
                            id="startDate"
                            name="startDate"
                            autoComplete="off"
                            placeholder="Select a date"
                            value={startDate}
                            component={FormikDatePicker}
                            onChange={handleStartDate}
                            disabled={true}
                          />
                          <InputGroupText
                            disabled={true}
                            onClick={() => handleDateClick("startDate")}
                          >
                            <img src={Calendar} alt="" />
                          </InputGroupText>
                        </InputGroup>
                        {errorStart && (
                          <div className="text-danger font-size-12">
                            Start Date is required
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="end-date-invoice">
                        <Label>End Date</Label>
                        <InputGroup onMouseLeave={handleMouseLeave}>
                          <Field
                            type="text"
                            id="endDate"
                            name="endDate"
                            autoComplete="off"
                            placeholder="Select a date"
                            value={endDate}
                            component={FormikDatePicker}
                            onChange={handleEndDate}
                            minDate={new Date(invStartDate)}
                            maxDate={new Date(maxDate)}
                          />
                          <InputGroupText
                            onClick={() => handleDateClick("endDate")}
                          >
                            <img src={Calendar} alt="" />
                          </InputGroupText>
                        </InputGroup>
                        {errorEnd && (
                          <div className="text-danger font-size-12">
                            End Date is required
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
                <Col md={6} className="d-flex justify-content-end m-auto">
                  <Row>
                    <Col md="auto" className="pt-2 mt-1">
                      <Label>{""}</Label>
                      <Button
                        onClick={handleClaims}
                        color="primary"
                        className="search"
                      >
                        Get Claims
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Card className="border-0 shadow-top">
                <CardBody className="section-devider-border">
                  <Row>
                    <div className="d-flex justify-content-between align-items-center">
                      <Col md="auto" className="pt-0">
                        <h5 className="f-16 text-primary font-weight-700 mb-0">
                          Manual Invoice Count ({invoiceData?.length})
                        </h5>
                      </Col>
                      <div className="d-flex justify-content-between align-items-center">
                        <Col md="auto" className="pt-0">
                          {onExport && (
                            <Button
                              hidden={invoiceID > 0}
                              size="sm"
                              color="export"
                              className="ms-auto"
                              onClick={handleExport}
                              disabled={!invoiceData.length}
                            >
                              <span className="right_5">
                                <img src={ExportIcon} alt="" />
                              </span>{" "}
                              Export
                            </Button>
                          )}
                        </Col>
                        <Col
                          md="auto"
                          hidden={hideGenerateButton}
                          className="pt-0"
                        >
                          <Label>{""}</Label>
                          <Button
                            onClick={handleSaveConfirmation}
                            color="primary"
                            className="ms-3 search"
                            style={{ float: "right" }}
                          >
                            <span className="right_5">
                              <img src={RefreshIcon} alt="" />
                            </span>{" "}
                            {invoiceID > 0
                              ? "ReGenerate Invoice"
                              : "Generate Invoice"}
                          </Button>
                        </Col>
                      </div>
                      {/* <Col md="auto" className="pt-0">
                        {onExport && (
                          <Button
                            hidden={invoiceID > 0}
                            size="sm"
                            color="export"
                            className="ms-auto"
                            onClick={handleExport}
                            disabled={!invoiceData.length}
                          >
                            <span className="right_5">
                              <img src={ExportIcon} alt="" />
                            </span>{" "}
                            Export
                          </Button>
                        )}
                      </Col>
                      <Col
                        md="auto"
                        hidden={hideGenerateButton}
                        className="pt-0"
                      >
                        <Label>{""}</Label>
                        <Button
                          onClick={handleSaveConfirmation}
                          color="primary"
                          className="ms-3 search"
                          style={{ float: "right" }}
                        >
                          <span className="right_5">
                            <img src={RefreshIcon} alt="" />
                          </span>{" "}
                          {invoiceID > 0
                            ? "ReGenerate Invoice"
                            : "Generate Invoice"}
                        </Button>
                      </Col> */}
                    </div>
                    <Col className="mt-2">
                      <div
                        className="table-card scroll-table position-relative border-0 rounded pt-0"
                        fixed-height={
                          invoiceData.length > 0 ? "fixed-height" : "default"
                        }
                      >
                        <ReactStrapTable
                          id="invoicedetail-table"
                          fixedColumn
                          data={invoiceData}
                          columns={columns}
                          onExport={handleExport}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-3 justify-content-end"></Row>
                </CardBody>
              </Card>
            </div>
          );
        }}
      ></Formik>
      <Confirm
        isOpen={isConfirm}
        message="Do you want to proceed in generating invoice, It will override previous invoice if any?"
        onToggle={handleSaveConfirmation}
        onCancel={handleSaveConfirmation}
        onContinue={handleGenerateInvoice}
      />

      <Confirm
        isOpen={isDeleteConfirm}
        message="Are you sure you want to delete line item?"
        onToggle={handleDeleteConfirmation}
        onCancel={handleDeleteConfirmation}
        onContinue={deleteRow}
      />
    </>
  );
};

export default ManualInvoice;
